/**
 * AIS history trails. Keeping the last stretch of each target's track lets the
 * eye read where it has been and where it's heading at a glance, the way a radar
 * leaves a tail. We only record a point once the target has actually moved a
 * meaningful step (so a stationary vessel doesn't pile up duplicates), and cap
 * the trail length so memory stays bounded with many targets.
 */
import { rhumbDistanceNm } from '@/nav';

/** Below this the target hasn't really moved, so we skip the point (~9 m). */
const MIN_MOVE_NM = 0.005;

/** Append a position to a target's trail, deduped and capped. */
export function appendTrailPoint(
  trail: [number, number][] | undefined,
  pos: [number, number],
  cap = 60,
): [number, number][] {
  const t = trail ?? [];
  const last = t[t.length - 1];
  if (last && rhumbDistanceNm(last, pos) < MIN_MOVE_NM) return t;
  const next = [...t, pos];
  if (next.length > cap) next.splice(0, next.length - cap);
  return next;
}
